import { Routes } from '@angular/router';
import { ReviewComponent } from './pages/review/review.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { LoginComponent } from './pages/login/login.component';
import { authGuard } from './guards/auth.guard';
import { UsersComponent } from './pages/users/users.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { CheckoutStatusComponent } from './pages/checkout/checkout-status.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [authGuard],
    component: LoginComponent,
  },
  {
    path: 'register',
    canActivate: [authGuard],
    component: RegisterComponent,
  },
  {
    path: 'forgot-password',
    canActivate: [authGuard],
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    canActivate: [authGuard],
    component: ForgotPasswordComponent,
  },
  {
    path: 'jobs',
    component: JobsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [authGuard],
  },
  {
    path: 'review',
    component: ReviewComponent,
  },
  {
    path: 'checkout/:status',
    component: CheckoutStatusComponent,
  }
];
